'use client';

import { useEffect } from 'react';
import { DataLayerEvent } from './DataLayerEvent';
import { DataLayerEventParams } from './DataLayerEventParams';
import { DataLayerKey } from './DataLayerKey';
import { DataLayerManager } from './DataLayerManager';
import { DataLayerT2SKey } from './DataLayerT2SKey';

const dataLayerManager = new DataLayerManager();

export type UseDataLayerReturnType = {
    trackEvent: (eventName: DataLayerEvent, params: DataLayerEventParams) => void;
    showPrivacyCenter: () => void;
    addVariable: (name: DataLayerKey, value: string | string[] | number) => void;
    addVariables: (variables: Partial<Record<DataLayerKey, string | string[] | number>>) => void;
    trackT2SEvent: (params: Record<DataLayerT2SKey, string>) => void;
    deleteVariable: (name: DataLayerKey) => void;
};

export const useDataLayer = (variables: Partial<Record<DataLayerKey, string>> = {}): UseDataLayerReturnType => {
    useEffect(() => {
        dataLayerManager.addVariables(variables);
    }, [variables]);

    const addVariable = (name: DataLayerKey, value: string | string[] | number) => {
        if (typeof window !== 'undefined') {
            dataLayerManager.addVariable(name, value);
        }
    };

    const addVariables = (variables: Partial<Record<DataLayerKey, string | string[] | number>>) => {
        if (typeof window !== 'undefined') {
            dataLayerManager.addVariables(variables);
        }
    };

    const deleteVariable = (name: DataLayerKey) => {
        if (typeof window !== 'undefined') {
            dataLayerManager.deleteVariable(name);
        }
    };

    const trackT2SEvent = (params: Record<DataLayerT2SKey, string>) => {
        if (typeof window !== 'undefined' && typeof window._t2sparams !== 'undefined') {
            dataLayerManager.trackT2SEvent(params);
        }
    };

    return {
        trackEvent: (eventName: DataLayerEvent, params: DataLayerEventParams) =>
            dataLayerManager.trackEvent(eventName, params),
        showPrivacyCenter: dataLayerManager.showPrivacyCenter,
        addVariable,
        addVariables,
        trackT2SEvent,
        deleteVariable,
    };
};
